export enum ILiveAlone {
    'At or Below $1,073',
    '$1,074 - $1,342',
    '$1,343 - $1,610',
    '$1,611 - $1,878',
    '$1,879 - $2,147',
    '$2,148 or over',
    Other,
}
